import React from 'react';

class Credits extends React.Component {
  render() {
    const theme = this.props.theme;
    return (
      theme ?
        <div className="flex items-center justify-center mt-4">
          <h6 className="text-sm sm:text-lg md:text-xl mr-2">Coded by</h6>
          <a href="https://www.frontendmentor.io/profile/fatihcaen">
            <h6 className="font-bold text-sm sm:text-lg md:text-xl text-blue-500 underline">Fatih Can</h6>
          </a>
        </div>
        :
        <div className="flex items-center justify-center mt-4">
          <h6 className="text-gray-400 text-sm sm:text-lg md:text-xl mr-2">Coded by</h6>
          <a href="https://www.frontendmentor.io/profile/fatihcaen">
            <h6 className="font-bold text-sm sm:text-lg md:text-xl text-blue-500 underline">Fatih Can</h6>
          </a>
        </div>
    );
  }
}

export default Credits;